import { Button, message, Radio, Statistic, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { TransactionList } from '../../../apis/Admin/Financials/TransactionList';
import { useGlobalState } from '../../../store/state';
import CurrencyIcon from '../../Common/CurrencyIcon';
import './HomeTabledComponents.styles.scss';

const WithdrawalsComponent = ({ className }) => {
  const [user] = useGlobalState('user');
  const [withdrawls, setWithdrawls]= useState({
    paging: {
      page: 1,
      limit: 10,
    },
    mode: 'influencers',
    type: 'withdraw',
    data: [],
  });

  const getTranscations = (mode, type, page, limit) =>{
    const _data = {
      mode,
      type,
      page,
      limit,
    };
    TransactionList(user.accessToken, _data).then(({ status, response })=>{
      console.log('transaction response', response);
      if (status === 200) {
        // message.success("widthdrawls listy sready")
        setWithdrawls({
          ...withdrawls,
          data: response.transactions.map((txn) =>{
            return {
              key: txn._id,
              walletId: txn.walletId,
              name: (txn.firstname || 'n/a')+ ' ' + (txn.lastname || ''),
              // handle:"@joedoe",
              // avatar:'/images/avatar.png',
              amount: txn.amount,
            };
          }),
        });
      }
    });
  };

  useEffect(()=>{
    const { mode, type, paging: { page, limit } } = withdrawls;
    getTranscations(mode, type, page, limit);
  }, []);

  const changeType = (e) =>{
    setWithdrawls({
      ...withdrawls,
      mode: e.target.value,
    });

    const { type, paging: { page, limit } } = withdrawls;
    getTranscations(e.target.value, type, page, limit);
  };


  const dataSource = [
    {
      key: '1',
      name: 'Joe Doe',
      handle: '@joedoe',
      avatar: '/images/avatar.png',
      amount: 15000,
    },
    {
      key: '2',
      name: 'Duran Clayton',
      handle: '@durangros',
      avatar: '/images/avatar.png',
      amount: 7520,
    },
    {
      key: '3',
      name: 'Dravid Rahul',
      handle: '@drrh',
      avatar: '/images/avatar.png',
      amount: 950000,
    },
    {
      key: '4',
      name: 'Duran Clayton',
      handle: '@durangros',
      avatar: '/images/avatar.png',
      amount: 7520,
    },
    {
      key: '5',
      name: 'gapsio',
      handle: '@gapsio',
      avatar: '/images/avatar.png',
      amount: 1020,
    },
    {
      key: '6',
      name: 'Gasxn Max',
      handle: '@gaxs',
      avatar: '/images/avatar.png',
      amount: 40500,
    },
    {
      key: '7',
      name: 'Maxiis',
      handle: '@maxis',
      avatar: '/images/avatar.png',
      amount: 65820,
    },
  ];

  const columns = [
    {
      width: 200,
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (value, rest) => (
        <div className="table_name_field">{value}<span>{rest.walletId}</span></div>
      ),
    },
    {
      width: 160,
      title: 'Amount Requested',
      dataIndex: 'amount',
      key: 'amount',
      sorter: (a, b) => a.amount - b.amount,
      render: (value) =>(
        <>{CurrencyIcon()}<Statistic value={value}
          className="custom_number_format"/></>
      ),
    },
    {
      width: 100,
      align: 'right',
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (value) =>(
        <a href="#"
          className="common_button outlined small my-1 d-inline-block py-1">Approve</a>
      ),
    },
  ];

  return (
    <div className={`${className}`}>
      <div className="common_card admin_stats_tabled p-3 h-100">
        <div className="admin_stats_tabled_top d-md-flex d-flex-wrap">
          <div className="col-md-7 p-0">
            <h4 className="mb-0">Withdraw Requests</h4>
            <p className="m-0">14+ Requests pending</p>
          </div>
          <div className="col-md-5 text-right p-0">
            <Radio.Group defaultValue="influencers"
              buttonStyle="solid"
              onChange={changeType}>
              <Radio.Button value="influencers">Influnencer</Radio.Button>
              <Radio.Button value="brands">Brand</Radio.Button>
            </Radio.Group>
          </div>
        </div>
        <div className="admin_stats_tabled_data pt-4">
          <Table className="tiny_table"
            dataSource={withdrawls.data}
            columns={columns}
            pagination={false} />
        </div>
      </div>
    </div>
  );
};

export default WithdrawalsComponent;
